/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardMembershipFeeDialogController', BoardMembershipFeeDialogController);

    BoardMembershipFeeDialogController.$inject = ['$timeout', '$scope', 'DateUtils', '$uibModalInstance', 'entity', '$http', 'AlertService'];

    function BoardMembershipFeeDialogController ($timeout, $scope, DateUtils, $uibModalInstance, entity, $http, AlertService) {
        var vm = this;

        vm.membershipFee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            minMode: 'year'
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.get('api/membership-fees/create/', {
                params: {
                    year: DateUtils.convertLocalDateToServer(vm.membershipFee.year)
                }
            }).then(function(response){
                AlertService.success("Es wurden " + response.headers('totalAdded') + " Mitgliedsbeiträge eingezogen.");
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }).catch(function(){
                vm.isSaving = false;
            });
        }
        vm.datePickerOpenStatus.year = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
